import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewChild
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ACLService } from '@delon/acl';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { SettingsService, User } from '@delon/theme';
import { AuthService } from 'src/app/core/util/auth.service';
import { SharedModule } from 'src/app/shared/shared.module';

import { MobileAppQrCodeComponent } from './mobile-app-qr-code/mobile-app-qr-code.component';
import { HeaderFullScreenComponent } from './fullscreen.component';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';

@Component({
  selector: 'header-user',
  standalone: true,
  imports: [NzAvatarModule, SharedModule, RouterModule, MobileAppQrCodeComponent, HeaderFullScreenComponent],
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserComponent {
  @ViewChild('mobileAppQrCodeComponent')
  mobileAppQrCode!: MobileAppQrCodeComponent;

  get user(): User {
    return this.settings.user;
  }
  get country() {
    return this.settings.user['company']?.country;
  }
  get academyLink() {
    if (this.country === 'PH') return 'https://academy.qne.cloud';

    return 'https://academy.qne.cloud/courses/qcamy';
  }
  get websiteLink() {
    if (this.country === 'PH') return 'https://qne.cloud/ph/';

    return 'https://qne.cloud/my/';
  }
  get youtubeLink() {
    if (this.country === 'PH') return 'https://www.youtube.com/@QNESoftwarePH';

    return 'https://www.youtube.com/@QnESoftwareChannel';
  }
  get releaseNotesLink() {
    if (this.country === 'PH') {
      return 'https://support-ph.qne.cloud/support/solutions/folders/35000252635';
    }
    return 'https://support.qne.com.my/support/solutions/folders/81000302605';
  }
  get company() {
    return this.settings.user['company'];
  }

  constructor(
    private readonly settings: SettingsService,
    private readonly authService: AuthService,
    private readonly router: Router,
    public acl: ACLService,
    @Inject(DA_SERVICE_TOKEN) private readonly tokenService: ITokenService
  ) {
    // obsolete: retrieve release notes by country
    // this.http
    //   .get(
    //     `api/releaseNotes/getByCountry?country=${this.country}&_silent=true`,
    //     {},
    //     { context: new HttpContext().set(ALLOW_ANONYMOUS, true) }
    //   )
    //   .subscribe((res: any[]) => {
    //     this.releaseNotes = [...res];
    //   });
  }

  logout(): void {
    this.authService.logout();
  }

  showManagePlan() {
    const tokenModel = this.tokenService.get();

    if (tokenModel) {
      const currentTenantId = tokenModel['tenantId'];

      this.router.navigate(['./account/subscription'], {
        queryParams: { tid: currentTenantId }
      });
    } else {
      // Handle the case when tokenModel is null
      // You can display an error message or take appropriate action
    }
  }
}
